import React from "react";
import { Grid, Typography, IconButton, Box } from "@mui/material";
import { Add } from "@mui/icons-material";
import FilterConditionRow from "./FilterConditionRow";
import { useLanguageContext } from "../../../Context/LanguageContext";
const ConditionList = ({
  conditions,
  filterList,
  handleConditionChange,
  handleRemoveCondition,
  handleAddCondition,
}) => {
  const { localization } = useLanguageContext();

  return (
    <div className="filterContainer">
      <div className="filterSegment">
        {conditions.map((condition, index) => (
          <FilterConditionRow
            key={index}
            index={index}
            condition={condition}
            filterList={filterList}
            handleConditionChange={handleConditionChange}
            handleRemoveCondition={handleRemoveCondition}
            conditionsLength={conditions.length}
          />
        ))}
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          className="filterComponentConditionStyle"
        >
          <IconButton onClick={handleAddCondition}>
            <Add />
          </IconButton>
          <Typography variant="body1">{localization.addCondition}</Typography>
        </Grid>
      </div>
    </div>
  );
};

export default ConditionList;
